import * as React from 'react';
import { ErrorRow, LoadingPlaceholderRows } from '../../search-status-rows';

interface Props {
  id: string;
  children: React.ReactNode;
  isLoading?: boolean;
  error: string | null | undefined;
  additionalClassNames?: string;
  heading?: string;
}

/**
 * Common component for showing data (non-search results) like Organization or Transaction (Billing) Account Details
 */
const DataDisplayTable = ({ isLoading, children, additionalClassNames, id, heading, error }: Props) => {
  const getDataTable = () => {
    if (error) {
      return <ErrorRow colSpan={2} error={error} />;
    }
    if (isLoading) {
      return <LoadingPlaceholderRows colSpan={2} numberOfRows={3} />;
    }

    if (children) {
      return children;
    }
  };

  return (
    <>
      <h2>{heading}</h2>
      <table id={id} className={`${additionalClassNames} aui table-list`} data-testid={`data-display-table-${id}`}>
        {/* TODO: Maybe make dynamic */}
        <colgroup>
          <col className={'col-15'} />
          <col className={'col-auto'} />
        </colgroup>
        {getDataTable()}
      </table>
    </>
  );
};

export default DataDisplayTable;
